import { render, staticRenderFns } from "./redemption.vue?vue&type=template&id=a5bb299a&"
import script from "./redemption.vue?vue&type=script&lang=js&"
export * from "./redemption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports